import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../Hooks/useFetch";
import { userContext } from "../../Contexts/userContext";
import Pricing from "../../Template/Home/Pricing/Pricing";
import { profileURL, categoriesWithPricesURL } from "../../Hooks/URL";

function PricingPage() {
  const { contextData, setContextData } = useContext(userContext);
  const page = "pricing";

  const [categories, setCategories] = useState([]);
  const { data, loading, error } = useFetch(categoriesWithPricesURL);

  useEffect(() => {
    if (!loading && !error && data) {
      setCategories(data.data || []);
    }
  }, [data, loading, error]);

  const {
    data: profileData,
    loading: profileLoading,
    error: profileError,
  } = useFetch(profileURL);
  const [profile, setProfile] = useState({});

  useEffect(() => {
    if (!profileLoading && !profileError && profileData) {
      setProfile(profileData.data);
    }
  }, [profileData, profileLoading, profileError]);

  return (
    <Pricing
      categories={categories}
      loading={loading}
      role={contextData?.role}
      profile={profile}
    />
  );
}

export default PricingPage;
